import RestService from '../services/rest';

async function getListTechnicalMaterial(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/technicalMaterial/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getCsvTechnicalMaterial() {
  const response = await RestService.getAuthenticated('panel/technicalMaterial/csv/model', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'technical-material-model.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvTechnicalMaterial(file) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated('panel/technicalMaterial/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function uploadFileTechnicalMaterial(file, fileName, technicalMaterialId) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(
    `panel/technicalMaterial/import?technicalMaterialId=${technicalMaterialId}&fileName=${fileName}`,
    fd, { 'Content-Type': 'multipart/form-data' },
  );
}

async function updateTechnicalMaterial(technicalMaterialParameter) {
  return RestService.putAuthenticated('panel/technicalMaterial/update', technicalMaterialParameter);
}

async function deleteTechnicalMaterial(technicalMaterialId) {
  return RestService.deleteAuthenticated('panel/technicalMaterial/delete', { technicalMaterialId });
}

export default {
  getListTechnicalMaterial,
  getCsvTechnicalMaterial,
  uploadCsvTechnicalMaterial,
  uploadFileTechnicalMaterial,
  updateTechnicalMaterial,
  deleteTechnicalMaterial,
};
